import React from 'react';

export interface RateAnswerProps {
  question: string;
  answer?: string;
  justificationLabel: string;
  description: string;
  isPositive: boolean;
}

const RateAnswer: React.FC<RateAnswerProps> = ({
  question,
  answer,
  justificationLabel = 'Uzasadnienie:',
  description,
  isPositive = true,
}) => {
  // Dynamicznie określamy kolor zależnie od typu odpowiedzi (pozytywna/negatywna)
  const answerBgColor = isPositive ? 'bg-[#148b4d]' : 'bg-red-600';
  const justificationTextColor = isPositive ? 'text-[#148b4d]' : 'text-red-600';
  const justificationStrokeColor = isPositive ? '#148B4D' : '#E53E3E'; // red-600
  const justificationFillColor = isPositive ? '#148B4D' : '#E53E3E'; // red-600

  return (
    <div className="flex w-full min-w-[300px] flex-col items-start justify-start gap-6">
      <div className="flex relative flex-col flex-grow-0 flex-shrink-0 gap-3 justify-start items-start">
        <p className="flex-grow-0 flex-shrink-0 self-stretch text-lg font-bold text-left text-text-primary">
          {question}
        </p>
        <div
          className={`relative flex flex-shrink-0 flex-grow-0 items-center justify-center gap-2.5 rounded-[5px] px-[22px] py-2 text-base font-bold uppercase leading-[16px] text-white ${answerBgColor}`}
        >
          {answer ? answer : isPositive ? 'TAK' : 'NIE'}
        </div>
      </div>
      <div className="flex relative flex-col flex-grow-0 flex-shrink-0 gap-3 justify-start items-start self-stretch">
        <div className="h-5 w-[118px] flex-shrink-0 flex-grow-0">
          <p
            className={`absolute left-[29px] top-1.5 text-left text-[13px] font-semibold ${justificationTextColor}`}
          >
            {justificationLabel}
          </p>
          <svg
            width={21}
            height={22}
            viewBox="0 0 21 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-[19.09px]"
            preserveAspectRatio="xMidYMid meet"
          >
            <path
              d="M4.91627 21L4.91534 15.4895H3.63065C2.18398 15.4895 1 14.3055 1 12.8579V3.63111C1 2.18398 2.18398 1 3.63065 1H17.4541C18.9017 1 20.0857 2.18398 20.0857 3.63111V12.8579C20.0857 14.3055 18.9017 15.4895 17.4541 15.4895H9.66472L4.91627 21Z"
              stroke={justificationStrokeColor}
              strokeWidth="1.5"
              strokeMiterlimit={10}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.0341 10.0979V10.0072C10.0406 9.41528 10.1006 8.94431 10.2141 8.59427C10.3309 8.24423 10.4964 7.96102 10.7105 7.74463C10.9246 7.52824 11.1825 7.33095 11.4842 7.15274C11.6788 7.03182 11.854 6.89658 12.0097 6.74702C12.1655 6.59745 12.2887 6.42562 12.3796 6.2315C12.4704 6.03739 12.5158 5.82259 12.5158 5.58711C12.5158 5.3039 12.4477 5.05887 12.3114 4.85203C12.1752 4.64519 11.9935 4.48608 11.7664 4.3747C11.5426 4.26014 11.2928 4.20286 11.017 4.20286C10.7672 4.20286 10.5288 4.25378 10.3017 4.35561C10.0746 4.45744 9.88646 4.61655 9.73723 4.83294C9.588 5.04614 9.50203 5.3214 9.47932 5.65871H8C8.02271 5.08592 8.17032 4.60223 8.44282 4.20764C8.71533 3.80986 9.07543 3.50915 9.52311 3.30549C9.97405 3.10183 10.472 3 11.017 3C11.614 3 12.1363 3.10979 12.5839 3.32936C13.0316 3.54574 13.3788 3.84964 13.6253 4.24105C13.8751 4.62928 14 5.08274 14 5.60143C14 5.95784 13.9432 6.27924 13.8297 6.56563C13.7161 6.84885 13.5539 7.10183 13.3431 7.32458C13.1354 7.54734 12.8856 7.74463 12.5937 7.91647C12.3179 8.08512 12.0941 8.26014 11.9221 8.44153C11.7534 8.62291 11.6302 8.83771 11.5523 9.08592C11.4745 9.33413 11.4323 9.64121 11.4258 10.0072V10.0979H10.0341ZM10.7689 13C10.5028 13 10.2741 12.9077 10.0827 12.7232C9.89132 12.5354 9.79562 12.3095 9.79562 12.0453C9.79562 11.7844 9.89132 11.5617 10.0827 11.3771C10.2741 11.1893 10.5028 11.0955 10.7689 11.0955C11.0316 11.0955 11.2587 11.1893 11.4501 11.3771C11.6448 11.5617 11.7421 11.7844 11.7421 12.0453C11.7421 12.2204 11.6967 12.3811 11.6058 12.5274C11.5182 12.6706 11.4015 12.7852 11.2555 12.8711C11.1095 12.957 10.9473 13 10.7689 13Z"
              fill={justificationFillColor}
            />
          </svg>
        </div>
        <div className="relative flex flex-shrink-0 flex-grow-0 items-center justify-center gap-2.5 self-stretch max-w-full overflow-hidden break-words">
          <p className="flex-grow min-w-0 break-words text-left text-[15px] text-text-primary">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default RateAnswer;
